import { isObject } from '@/utils'
import Vue from 'vue'
import vueLoading from './index.vue'

let queue = []

function isInDocument(element) {
  return document.body.contains(element)
}

function createInstance() {
  queue = queue.filter(item => !item.$el.parentNode || isInDocument(item.$el))
  if (!queue.length) {
    const toast = new (Vue.extend(vueLoading))({
      el: document.createElement('div')
    })
    document.body.appendChild(toast.$el)
    queue.push(toast)
  }
  return queue[queue.length - 1]
}

function Loading() {
  const l = createInstance()
  l.clear = () => {
    l.value = false
  }
  return l
}
const createMethod = type => options => Loading()

;['loading'].forEach(method => {
  Loading[method] = createMethod(method)
})

Loading.clear = all => {
  if (queue.length) {
    if (all) {
      queue.forEach(toast => {
        toast.clear()
      })
      queue = []
    } else {
      queue.shift().clear()
    }
  }
}

Loading.install = () => {
  Vue.use(vueLoading)
}
// 和kw-loading区分开
Vue.prototype.$miniLoading = Loading

function removeNode(el) {
  const parent = el.parentNode

  if (parent) {
    parent.removeChild(el)
  }
}

export default Loading
